import {
  SubWorkflow,
  WorkflowDetails,
  WorkflowTask,
} from '@qtek/shared/models';

export function updateNestedSubWorkflow(
  workflows: WorkflowDetails[],
  subWorkflowId: string,
  updateFn: (sw: SubWorkflow) => SubWorkflow
): WorkflowDetails[] {
  return workflows.map(w => {
    const subIdx =
      w.subWorkflows?.findIndex(sw => sw._id === subWorkflowId) ?? -1;
    if (subIdx === -1) return w;
    const updatedSubs = [...w.subWorkflows];
    updatedSubs[subIdx] = updateFn(updatedSubs[subIdx]);
    return { ...w, subWorkflows: updatedSubs };
  });
}

export function upsertNestedSubWorkflow(
  workflows: WorkflowDetails[],
  subWorkflow: SubWorkflow
): WorkflowDetails[] {
  const subExists = workflows.some(w =>
    w.subWorkflows?.some(sw => sw._id === subWorkflow._id)
  );

  if (subExists) {
    return updateNestedSubWorkflow(workflows, subWorkflow._id, sw => ({
      ...sw,
      ...subWorkflow,
    }));
  }

  return workflows.map(w =>
    w._id === subWorkflow.parentWorkflowId
      ? { ...w, subWorkflows: [...(w.subWorkflows || []), subWorkflow] }
      : w
  );
}

export function updateWorkflowTasks(
  workflows: WorkflowDetails[],
  workflowId: string,
  updateFn: (tasks: WorkflowTask[]) => WorkflowTask[]
): WorkflowDetails[] {
  return workflows.map(workflow => {
    if (workflow._id === workflowId) {
      return {
        ...workflow,
        workflowTasks: updateFn(workflow.workflowTasks || []),
      };
    }
    if (workflow.subWorkflows?.some(sw => sw._id === workflowId)) {
      return {
        ...workflow,
        subWorkflows: workflow.subWorkflows.map(sw =>
          sw._id === workflowId
            ? { ...sw, workflowTasks: updateFn(sw.workflowTasks || []) }
            : sw
        ),
      };
    }
    return workflow;
  });
}
